var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section form-column address-format-from" },
    [
      _c(
        "span",
        {
          staticClass: "title",
          attrs: { title: _vm.$t("SeaExport.ShippingAndReceivingInformation") }
        },
        [_vm._v(_vm._s(_vm.getItemTitle("Customer Information")))]
      ),
      _c(
        "el-form",
        {
          staticStyle: { height: "100%" },
          attrs: {
            disabled: _vm.readonly,
            "label-width": "110px",
            "label-position": "right"
          }
        },
        [
          _c(
            "el-form-item",
            {
              class: _vm.isDifferent("shipperLine2"),
              attrs: {
                label: _vm.getItemTitle("Shipper"),
                title: _vm.$t("SeaExport.ShipperName")
              }
            },
            [
              _c(
                "div",
                { staticStyle: { display: "flex", "margin-bottom": "5px" } },
                [
                  _c("cargo-company-select", {
                    staticStyle: {
                      display: "inline-block",
                      width: "175px",
                      "margin-right": "5px"
                    },
                    attrs: {
                      no: "shipperId",
                      "method-params": { shipper: true, active: true },
                      "default-value": _vm.addressForm.shipperCode || "",
                      "allow-create": true,
                      placeholder: _vm.readonly ? "" : "CODE"
                    },
                    on: {
                      change: function(data) {
                        _vm.shipperChange(data)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "vertical-align": "top" },
                      attrs: { no: "shipperIdBtn", type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.billAddressDialog.visible = true
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")) + " ")]
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "el-form-item",
            {
              class:
                _vm.lengthOverName(_vm.addressForm.shipperLine1) ||
                _vm.isDifferent("shipperLine1"),
              attrs: { label: "Name", title: _vm.$t("SeaExport.Name") }
            },
            [
              _c(
                "span",
                { attrs: { slot: "label" }, slot: "label" },
                [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: _vm.$t("CargoMsg.Cargo_AmsShipperLine1tip"),
                        placement: "right-end"
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon-question",
                        staticStyle: { cursor: "pointer", color: "#1F75D5" }
                      })
                    ]
                  ),
                  _vm._v(" " + _vm._s(_vm.getItemTitle("Name")) + " "),
                  _c("i", {
                    staticClass: "el-icon-search",
                    staticStyle: {
                      color: "blue",
                      "font-weight": "1000",
                      cursor: "pointer"
                    },
                    attrs: { no: "iconSearch3" },
                    on: {
                      click: function($event) {
                        return _vm.showSearchBoxAfrAddressDialog(
                          "shipper",
                          _vm.addressForm.shipperLine1
                        )
                      }
                    }
                  })
                ],
                1
              ),
              !_vm.isEFreight
                ? _c("el-input", {
                    attrs: { no: "1" },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showSenderAndReceiverDialog("shipper", 4)
                      }
                    },
                    model: {
                      value: _vm.addressForm.shipperLine1,
                      callback: function($$v) {
                        _vm.$set(_vm.addressForm, "shipperLine1", $$v)
                      },
                      expression: "addressForm.shipperLine1"
                    }
                  })
                : _vm._e(),
              _vm.isEFreight
                ? _c("el-input", {
                    attrs: { no: "42" },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.eFreightShowSenderAndReceiverDialog(
                          "shipperLineName",
                          1
                        )
                      }
                    },
                    model: {
                      value: _vm.addressForm.shipperLine1,
                      callback: function($$v) {
                        _vm.$set(_vm.addressForm, "shipperLine1", $$v)
                      },
                      expression: "addressForm.shipperLine1"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              class:
                _vm.lengthOverAddr(_vm.addressForm.shipperLine3) ||
                _vm.isDifferent("shipperLine3"),
              attrs: {
                label: _vm.getItemTitle("Address") + "1",
                title: _vm.$t("SeaExport.Addr") + "1"
              }
            },
            [
              !_vm.isEFreight
                ? _c("el-input", {
                    attrs: { no: "2" },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showSenderAndReceiverDialog("shipper", 4)
                      }
                    },
                    model: {
                      value: _vm.addressForm.shipperLine3,
                      callback: function($$v) {
                        _vm.$set(_vm.addressForm, "shipperLine3", $$v)
                      },
                      expression: "addressForm.shipperLine3"
                    }
                  })
                : _vm._e(),
              _vm.isEFreight
                ? _c("el-input", {
                    attrs: { no: "43" },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.eFreightShowSenderAndReceiverDialog(
                          "shipperLineAddress",
                          4
                        )
                      }
                    },
                    model: {
                      value: _vm.addressForm.shipperLine3,
                      callback: function($$v) {
                        _vm.$set(_vm.addressForm, "shipperLine3", $$v)
                      },
                      expression: "addressForm.shipperLine3"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              class:
                _vm.lengthOverAddr(_vm.addressForm.shipperLine4) ||
                _vm.isDifferent("shipperLine4"),
              attrs: {
                label: _vm.getItemTitle("Address") + "2",
                title: _vm.$t("SeaExport.Addr") + "2"
              }
            },
            [
              !_vm.isEFreight
                ? _c("el-input", {
                    attrs: { no: "3" },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showSenderAndReceiverDialog("shipper", 4)
                      }
                    },
                    model: {
                      value: _vm.addressForm.shipperLine4,
                      callback: function($$v) {
                        _vm.$set(_vm.addressForm, "shipperLine4", $$v)
                      },
                      expression: "addressForm.shipperLine4"
                    }
                  })
                : _vm._e(),
              _vm.isEFreight
                ? _c("el-input", {
                    attrs: { no: "44" },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.eFreightShowSenderAndReceiverDialog(
                          "shipperLineAddress",
                          4
                        )
                      }
                    },
                    model: {
                      value: _vm.addressForm.shipperLine4,
                      callback: function($$v) {
                        _vm.$set(_vm.addressForm, "shipperLine4", $$v)
                      },
                      expression: "addressForm.shipperLine4"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "warning",
              attrs: { label: _vm.$t("SeaExport.NotBeSent") }
            },
            [
              !_vm.isEFreight
                ? _c("el-input", {
                    attrs: { no: "4" },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showSenderAndReceiverDialog("shipper", 4)
                      }
                    },
                    model: {
                      value: _vm.addressForm.shipperLine5,
                      callback: function($$v) {
                        _vm.$set(_vm.addressForm, "shipperLine5", $$v)
                      },
                      expression: "addressForm.shipperLine5"
                    }
                  })
                : _vm._e(),
              _vm.isEFreight
                ? _c("el-input", {
                    attrs: { no: "44" },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.eFreightShowSenderAndReceiverDialog(
                          "shipperLineAddress",
                          4
                        )
                      }
                    },
                    model: {
                      value: _vm.addressForm.shipperLine5,
                      callback: function($$v) {
                        _vm.$set(_vm.addressForm, "shipperLine5", $$v)
                      },
                      expression: "addressForm.shipperLine5"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !(_vm.jsSendHide && _vm.isAms),
                  expression: "!(jsSendHide && isAms)"
                }
              ]
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.getItemTitle("Country"),
                    title: _vm.$t("SeaExport.Country")
                  }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      !_vm.jsSendHide
                        ? _c("el-input", {
                            class: _vm.isDifferent("shipperCountry"),
                            attrs: { maxlength: 2, no: "5" },
                            model: {
                              value: _vm.addressForm.shipperCountry,
                              callback: function($$v) {
                                _vm.$set(_vm.addressForm, "shipperCountry", $$v)
                              },
                              expression: "addressForm.shipperCountry"
                            }
                          })
                        : _c("cargo-advance-select", {
                            attrs: {
                              "select-type": _vm.TYPE_NAMES.basic_data_Country,
                              cache: false,
                              filterable: "",
                              "default-value": _vm.addressForm.shipperCountry,
                              "filter-tag-names": [
                                "code",
                                "chineseName",
                                "name"
                              ],
                              "tag-name": "code",
                              "tag-value": "code"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.addressForm.shipperCountry = p.value
                              }
                            }
                          }),
                      _c(
                        "span",
                        {
                          staticClass: "center-label",
                          attrs: { title: _vm.$t("SeaExport.Province") }
                        },
                        [_vm._v(_vm._s(_vm.getItemTitle("State")))]
                      ),
                      _c("el-input", {
                        class: _vm.isDifferent("shipperProvince"),
                        attrs: { maxlength: _vm.maxInputLength, no: "6" },
                        model: {
                          value: _vm.addressForm.shipperProvince,
                          callback: function($$v) {
                            _vm.$set(_vm.addressForm, "shipperProvince", $$v)
                          },
                          expression: "addressForm.shipperProvince"
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.getItemTitle("City"),
                    title: _vm.$t("SeaExport.City")
                  }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("el-input", {
                        class: _vm.isDifferent("shipperCity"),
                        attrs: { no: "7" },
                        model: {
                          value: _vm.addressForm.shipperCity,
                          callback: function($$v) {
                            _vm.$set(_vm.addressForm, "shipperCity", $$v)
                          },
                          expression: "addressForm.shipperCity"
                        }
                      }),
                      _c(
                        "span",
                        {
                          staticClass: "center-label",
                          attrs: { title: _vm.$t("SeaExport.ZIP") }
                        },
                        [_vm._v(_vm._s(_vm.getItemTitle("Zip")))]
                      ),
                      _c("el-input", {
                        class: _vm.isDifferent("shipperPostalcode"),
                        attrs: {
                          placeholder: _vm.readonly
                            ? ""
                            : _vm.$t("SeaExport.ZipForCountry"),
                          no: "8"
                        },
                        model: {
                          value: _vm.addressForm.shipperPostalcode,
                          callback: function($$v) {
                            _vm.$set(_vm.addressForm, "shipperPostalcode", $$v)
                          },
                          expression: "addressForm.shipperPostalcode"
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !(_vm.jsSendHide && _vm.isAci),
                      expression: "!(jsSendHide && isAci)"
                    }
                  ],
                  attrs: {
                    label: _vm.getItemTitle("Tel"),
                    title: _vm.$t("SeaExport.Phone")
                  }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.readonly
                            ? ""
                            : _vm.$t("SeaExport.Optional"),
                          no: "9"
                        },
                        model: {
                          value: _vm.addressForm.shipperTel,
                          callback: function($$v) {
                            _vm.$set(_vm.addressForm, "shipperTel", $$v)
                          },
                          expression: "addressForm.shipperTel"
                        }
                      }),
                      _c(
                        "span",
                        {
                          staticClass: "center-label",
                          attrs: { title: _vm.$t("SeaExport.Fax") }
                        },
                        [_vm._v(_vm._s(_vm.getItemTitle("Fax")))]
                      ),
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.readonly
                            ? ""
                            : _vm.$t("SeaExport.Optional"),
                          no: "10"
                        },
                        model: {
                          value: _vm.addressForm.shipperFax,
                          callback: function($$v) {
                            _vm.$set(_vm.addressForm, "shipperFax", $$v)
                          },
                          expression: "addressForm.shipperFax"
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _c("div", { staticStyle: { "margin-bottom": "10px" } })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              class: _vm.isDifferent("consigneeLine2"),
              attrs: {
                label: _vm.getItemTitle("Consignee"),
                title: _vm.$t("SeaExport.ConsigneeName")
              }
            },
            [
              _c(
                "div",
                { staticStyle: { display: "flex", "margin-bottom": "5px" } },
                [
                  _c("cargo-company-select", {
                    staticStyle: {
                      display: "inline-block",
                      width: "175px",
                      "margin-right": "5px"
                    },
                    attrs: {
                      no: "shipperId",
                      "method-params": { shipper: true, active: true },
                      "default-value": _vm.addressForm.consigneeCode || "",
                      "allow-create": true,
                      placeholder: _vm.readonly ? "" : "CODE"
                    },
                    on: {
                      change: function(data) {
                        _vm.consigneeChange(data)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "vertical-align": "top" },
                      attrs: { no: "shipperIdBtn", type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.billAddressDialog.visible = true
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")) + " ")]
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "el-form-item",
            {
              class:
                _vm.lengthOverName(_vm.addressForm.consigneeLine1) ||
                _vm.isDifferent("consigneeLine1"),
              attrs: {
                label: _vm.getItemTitle("Name"),
                title: _vm.$t("SeaExport.Name")
              }
            },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v(" " + _vm._s(_vm.getItemTitle("Name")) + " "),
                _c("i", {
                  staticClass: "el-icon-search",
                  staticStyle: {
                    color: "blue",
                    "font-weight": "1000",
                    cursor: "pointer"
                  },
                  attrs: { no: "iconSearch1" },
                  on: {
                    click: function($event) {
                      return _vm.showSearchBoxAfrAddressDialog(
                        "consignee",
                        _vm.addressForm.consigneeLine1
                      )
                    }
                  }
                })
              ]),
              !_vm.isEFreight
                ? _c("el-input", {
                    attrs: { no: "11" },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showSenderAndReceiverDialog("consignee", 4)
                      }
                    },
                    model: {
                      value: _vm.addressForm.consigneeLine1,
                      callback: function($$v) {
                        _vm.$set(_vm.addressForm, "consigneeLine1", $$v)
                      },
                      expression: "addressForm.consigneeLine1"
                    }
                  })
                : _vm._e(),
              _vm.isEFreight
                ? _c("el-input", {
                    attrs: { no: "45" },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.eFreightShowSenderAndReceiverDialog(
                          "consigneeLineName",
                          1
                        )
                      }
                    },
                    model: {
                      value: _vm.addressForm.consigneeLine1,
                      callback: function($$v) {
                        _vm.$set(_vm.addressForm, "consigneeLine1", $$v)
                      },
                      expression: "addressForm.consigneeLine1"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              class:
                _vm.lengthOverAddr(_vm.addressForm.consigneeLine3) ||
                _vm.isDifferent("consigneeLine3"),
              attrs: {
                label: _vm.getItemTitle("Address") + "1",
                title: _vm.$t("SeaExport.Addr") + "1"
              }
            },
            [
              !_vm.isEFreight
                ? _c("el-input", {
                    attrs: { no: "12" },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showSenderAndReceiverDialog("consignee", 4)
                      }
                    },
                    model: {
                      value: _vm.addressForm.consigneeLine3,
                      callback: function($$v) {
                        _vm.$set(_vm.addressForm, "consigneeLine3", $$v)
                      },
                      expression: "addressForm.consigneeLine3"
                    }
                  })
                : _vm._e(),
              _vm.isEFreight
                ? _c("el-input", {
                    attrs: { no: "46" },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.eFreightShowSenderAndReceiverDialog(
                          "consigneeLineAddress",
                          4
                        )
                      }
                    },
                    model: {
                      value: _vm.addressForm.consigneeLine3,
                      callback: function($$v) {
                        _vm.$set(_vm.addressForm, "consigneeLine3", $$v)
                      },
                      expression: "addressForm.consigneeLine3"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              class:
                _vm.lengthOverAddr(_vm.addressForm.consigneeLine4) ||
                _vm.isDifferent("consigneeLine4"),
              attrs: {
                label: _vm.getItemTitle("Address") + "2",
                title: _vm.$t("SeaExport.Addr") + "2"
              }
            },
            [
              !_vm.isEFreight
                ? _c("el-input", {
                    attrs: { no: "13" },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showSenderAndReceiverDialog("consignee", 4)
                      }
                    },
                    model: {
                      value: _vm.addressForm.consigneeLine4,
                      callback: function($$v) {
                        _vm.$set(_vm.addressForm, "consigneeLine4", $$v)
                      },
                      expression: "addressForm.consigneeLine4"
                    }
                  })
                : _vm._e(),
              _vm.isEFreight
                ? _c("el-input", {
                    attrs: { no: "47" },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.eFreightShowSenderAndReceiverDialog(
                          "consigneeLineAddress",
                          4
                        )
                      }
                    },
                    model: {
                      value: _vm.addressForm.consigneeLine4,
                      callback: function($$v) {
                        _vm.$set(_vm.addressForm, "consigneeLine4", $$v)
                      },
                      expression: "addressForm.consigneeLine4"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "warning",
              attrs: { label: _vm.$t("SeaExport.NotBeSent") }
            },
            [
              !_vm.isEFreight
                ? _c("el-input", {
                    attrs: { no: "14" },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showSenderAndReceiverDialog("consignee", 4)
                      }
                    },
                    model: {
                      value: _vm.addressForm.consigneeLine5,
                      callback: function($$v) {
                        _vm.$set(_vm.addressForm, "consigneeLine5", $$v)
                      },
                      expression: "addressForm.consigneeLine5"
                    }
                  })
                : _vm._e(),
              _vm.isEFreight
                ? _c("el-input", {
                    attrs: { no: "48" },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.eFreightShowSenderAndReceiverDialog(
                          "consigneeLineAddress",
                          4
                        )
                      }
                    },
                    model: {
                      value: _vm.addressForm.consigneeLine5,
                      callback: function($$v) {
                        _vm.$set(_vm.addressForm, "consigneeLine5", $$v)
                      },
                      expression: "addressForm.consigneeLine5"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !(_vm.jsSendHide && _vm.isAms),
                  expression: "!(jsSendHide && isAms)"
                }
              ]
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.getItemTitle("Country"),
                    title: _vm.$t("SeaExport.Country")
                  }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      !_vm.jsSendHide
                        ? _c("el-input", {
                            class: _vm.isDifferent("consigneeCountry"),
                            attrs: { maxlength: 2, no: "15" },
                            model: {
                              value: _vm.addressForm.consigneeCountry,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.addressForm,
                                  "consigneeCountry",
                                  $$v
                                )
                              },
                              expression: "addressForm.consigneeCountry"
                            }
                          })
                        : _c("cargo-advance-select", {
                            attrs: {
                              "select-type": _vm.TYPE_NAMES.basic_data_Country,
                              cache: false,
                              filterable: "",
                              "default-value": _vm.addressForm.consigneeCountry,
                              "filter-tag-names": [
                                "code",
                                "chineseName",
                                "name"
                              ],
                              "tag-name": "code",
                              "tag-value": "code"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.addressForm.consigneeCountry = p.value
                              }
                            }
                          }),
                      _c(
                        "span",
                        {
                          staticClass: "center-label",
                          attrs: { title: _vm.$t("SeaExport.Province") }
                        },
                        [_vm._v(_vm._s(_vm.getItemTitle("State")))]
                      ),
                      _c("el-input", {
                        class: _vm.isDifferent("consigneeProvince"),
                        attrs: { maxlength: _vm.maxInputLength, no: "16" },
                        model: {
                          value: _vm.addressForm.consigneeProvince,
                          callback: function($$v) {
                            _vm.$set(_vm.addressForm, "consigneeProvince", $$v)
                          },
                          expression: "addressForm.consigneeProvince"
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.getItemTitle("City"),
                    title: _vm.$t("SeaExport.City")
                  }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("el-input", {
                        class: _vm.isDifferent("consigneeCity"),
                        attrs: { no: "17" },
                        model: {
                          value: _vm.addressForm.consigneeCity,
                          callback: function($$v) {
                            _vm.$set(_vm.addressForm, "consigneeCity", $$v)
                          },
                          expression: "addressForm.consigneeCity"
                        }
                      }),
                      _c(
                        "span",
                        {
                          staticClass: "center-label",
                          attrs: { title: _vm.$t("SeaExport.ZIP") }
                        },
                        [_vm._v(_vm._s(_vm.getItemTitle("Zip")))]
                      ),
                      _c("el-input", {
                        class: _vm.isDifferent("consigneePostalcode"),
                        attrs: {
                          placeholder: _vm.readonly
                            ? ""
                            : _vm.$t("SeaExport.ZipForCountry"),
                          no: "18"
                        },
                        model: {
                          value: _vm.addressForm.consigneePostalcode,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.addressForm,
                              "consigneePostalcode",
                              $$v
                            )
                          },
                          expression: "addressForm.consigneePostalcode"
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !(_vm.jsSendHide && _vm.isAci),
                      expression: "!(jsSendHide && isAci)"
                    }
                  ],
                  attrs: {
                    label: _vm.getItemTitle("Tel"),
                    title: _vm.$t("SeaExport.Phone")
                  }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.readonly
                            ? ""
                            : _vm.$t("SeaExport.Optional"),
                          no: "19"
                        },
                        model: {
                          value: _vm.addressForm.consigneeTel,
                          callback: function($$v) {
                            _vm.$set(_vm.addressForm, "consigneeTel", $$v)
                          },
                          expression: "addressForm.consigneeTel"
                        }
                      }),
                      _c(
                        "span",
                        {
                          staticClass: "center-label",
                          attrs: { title: _vm.$t("SeaExport.Fax") }
                        },
                        [_vm._v(_vm._s(_vm.getItemTitle("Fax")))]
                      ),
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.readonly
                            ? ""
                            : _vm.$t("SeaExport.Optional"),
                          no: "20"
                        },
                        model: {
                          value: _vm.addressForm.consigneeFax,
                          callback: function($$v) {
                            _vm.$set(_vm.addressForm, "consigneeFax", $$v)
                          },
                          expression: "addressForm.consigneeFax"
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _c("div", { staticStyle: { "margin-bottom": "10px" } })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              class: _vm.isDifferent("notifyLine2"),
              attrs: {
                label: _vm.getItemTitle("Notify Party"),
                title: _vm.$t("SeaExport.NotifierName")
              }
            },
            [
              _c(
                "div",
                { staticStyle: { display: "flex", "margin-bottom": "5px" } },
                [
                  _c("cargo-company-select", {
                    staticStyle: {
                      display: "inline-block",
                      width: "175px",
                      "margin-right": "5px"
                    },
                    attrs: {
                      no: "shipperId",
                      "method-params": { shipper: true, active: true },
                      "default-value": _vm.addressForm.notifyCode || "",
                      "allow-create": true,
                      placeholder: _vm.readonly ? "" : "CODE"
                    },
                    on: {
                      change: function(data) {
                        _vm.notifyChange(data)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "vertical-align": "top" },
                      attrs: { no: "shipperIdBtn", type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.billAddressDialog.visible = true
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")) + " ")]
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "el-form-item",
            {
              class:
                _vm.lengthOverName(_vm.addressForm.notifyLine1) ||
                _vm.isDifferent("notifyLine1"),
              attrs: { label: "Name", title: _vm.$t("SeaExport.Name") }
            },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v(" " + _vm._s(_vm.getItemTitle("Name")) + " "),
                _c("i", {
                  staticClass: "el-icon-search",
                  staticStyle: {
                    color: "blue",
                    "font-weight": "1000",
                    cursor: "pointer"
                  },
                  attrs: { no: "iconSearch2" },
                  on: {
                    click: function($event) {
                      return _vm.showSearchBoxAfrAddressDialog(
                        "notify",
                        _vm.addressForm.notifyLine1
                      )
                    }
                  }
                })
              ]),
              !_vm.isEFreight
                ? _c("el-input", {
                    attrs: { no: "21" },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showSenderAndReceiverDialog("notify", 4)
                      }
                    },
                    model: {
                      value: _vm.addressForm.notifyLine1,
                      callback: function($$v) {
                        _vm.$set(_vm.addressForm, "notifyLine1", $$v)
                      },
                      expression: "addressForm.notifyLine1"
                    }
                  })
                : _vm._e(),
              _vm.isEFreight
                ? _c("el-input", {
                    attrs: { no: "49" },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.eFreightShowSenderAndReceiverDialog(
                          "notifyLineName",
                          1
                        )
                      }
                    },
                    model: {
                      value: _vm.addressForm.notifyLine1,
                      callback: function($$v) {
                        _vm.$set(_vm.addressForm, "notifyLine1", $$v)
                      },
                      expression: "addressForm.notifyLine1"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              class:
                _vm.lengthOverAddr(_vm.addressForm.notifyLine3) ||
                _vm.isDifferent("notifyLine3"),
              attrs: {
                label: _vm.getItemTitle("Address") + "1",
                title: _vm.$t("SeaExport.Addr") + "1"
              }
            },
            [
              !_vm.isEFreight
                ? _c("el-input", {
                    attrs: { no: "22" },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showSenderAndReceiverDialog("notify", 4)
                      }
                    },
                    model: {
                      value: _vm.addressForm.notifyLine3,
                      callback: function($$v) {
                        _vm.$set(_vm.addressForm, "notifyLine3", $$v)
                      },
                      expression: "addressForm.notifyLine3"
                    }
                  })
                : _vm._e(),
              _vm.isEFreight
                ? _c("el-input", {
                    attrs: { no: "50" },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.eFreightShowSenderAndReceiverDialog(
                          "notifyLineAddress",
                          4
                        )
                      }
                    },
                    model: {
                      value: _vm.addressForm.notifyLine3,
                      callback: function($$v) {
                        _vm.$set(_vm.addressForm, "notifyLine3", $$v)
                      },
                      expression: "addressForm.notifyLine3"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              class:
                _vm.lengthOverAddr(_vm.addressForm.notifyLine4) ||
                _vm.isDifferent("notifyLine4"),
              attrs: {
                label: _vm.getItemTitle("Address") + "2",
                title: _vm.$t("SeaExport.Addr") + "2"
              }
            },
            [
              !_vm.isEFreight
                ? _c("el-input", {
                    attrs: { no: "23" },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showSenderAndReceiverDialog("notify", 4)
                      }
                    },
                    model: {
                      value: _vm.addressForm.notifyLine4,
                      callback: function($$v) {
                        _vm.$set(_vm.addressForm, "notifyLine4", $$v)
                      },
                      expression: "addressForm.notifyLine4"
                    }
                  })
                : _vm._e(),
              _vm.isEFreight
                ? _c("el-input", {
                    attrs: { no: "51" },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.eFreightShowSenderAndReceiverDialog(
                          "notifyLineAddress",
                          4
                        )
                      }
                    },
                    model: {
                      value: _vm.addressForm.notifyLine4,
                      callback: function($$v) {
                        _vm.$set(_vm.addressForm, "notifyLine4", $$v)
                      },
                      expression: "addressForm.notifyLine4"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "warning",
              attrs: { label: _vm.$t("SeaExport.NotBeSent") }
            },
            [
              !_vm.isEFreight
                ? _c("el-input", {
                    attrs: { no: "24" },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showSenderAndReceiverDialog("notify", 4)
                      }
                    },
                    model: {
                      value: _vm.addressForm.notifyLine5,
                      callback: function($$v) {
                        _vm.$set(_vm.addressForm, "notifyLine5", $$v)
                      },
                      expression: "addressForm.notifyLine5"
                    }
                  })
                : _vm._e(),
              _vm.isEFreight
                ? _c("el-input", {
                    attrs: { no: "52" },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.eFreightShowSenderAndReceiverDialog(
                          "notifyLineAddress",
                          4
                        )
                      }
                    },
                    model: {
                      value: _vm.addressForm.notifyLine5,
                      callback: function($$v) {
                        _vm.$set(_vm.addressForm, "notifyLine5", $$v)
                      },
                      expression: "addressForm.notifyLine5"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !(_vm.jsSendHide && _vm.isAms),
                  expression: "!(jsSendHide && isAms)"
                }
              ]
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.getItemTitle("Country"),
                    title: _vm.$t("SeaExport.Country")
                  }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      !_vm.jsSendHide
                        ? _c("el-input", {
                            class: _vm.isDifferent("notifyCountry"),
                            attrs: { maxlength: 2, no: "25" },
                            model: {
                              value: _vm.addressForm.notifyCountry,
                              callback: function($$v) {
                                _vm.$set(_vm.addressForm, "notifyCountry", $$v)
                              },
                              expression: "addressForm.notifyCountry"
                            }
                          })
                        : _c("cargo-advance-select", {
                            attrs: {
                              "select-type": _vm.TYPE_NAMES.basic_data_Country,
                              cache: false,
                              filterable: "",
                              "default-value": _vm.addressForm.notifyCountry,
                              "filter-tag-names": [
                                "code",
                                "chineseName",
                                "name"
                              ],
                              "tag-name": "code",
                              "tag-value": "code"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.addressForm.notifyCountry = p.value
                              }
                            }
                          }),
                      _c(
                        "span",
                        {
                          staticClass: "center-label",
                          attrs: { title: _vm.$t("SeaExport.Province") }
                        },
                        [_vm._v(_vm._s(_vm.getItemTitle("State")))]
                      ),
                      _c("el-input", {
                        class: _vm.isDifferent("notifyProvince"),
                        attrs: { maxlength: "2", no: "26" },
                        model: {
                          value: _vm.addressForm.notifyProvince,
                          callback: function($$v) {
                            _vm.$set(_vm.addressForm, "notifyProvince", $$v)
                          },
                          expression: "addressForm.notifyProvince"
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.getItemTitle("City"),
                    title: _vm.$t("SeaExport.City")
                  }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("el-input", {
                        class: _vm.isDifferent("notifyCity"),
                        attrs: { no: "27" },
                        model: {
                          value: _vm.addressForm.notifyCity,
                          callback: function($$v) {
                            _vm.$set(_vm.addressForm, "notifyCity", $$v)
                          },
                          expression: "addressForm.notifyCity"
                        }
                      }),
                      _c(
                        "span",
                        {
                          staticClass: "center-label",
                          attrs: { title: _vm.$t("SeaExport.ZIP") }
                        },
                        [_vm._v(_vm._s(_vm.getItemTitle("Zip")))]
                      ),
                      _c("el-input", {
                        class: _vm.isDifferent("notifyPostalcode"),
                        attrs: {
                          placeholder: _vm.readonly
                            ? ""
                            : _vm.$t("SeaExport.ZipForCountry"),
                          no: "28"
                        },
                        model: {
                          value: _vm.addressForm.notifyPostalcode,
                          callback: function($$v) {
                            _vm.$set(_vm.addressForm, "notifyPostalcode", $$v)
                          },
                          expression: "addressForm.notifyPostalcode"
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !(_vm.jsSendHide && _vm.isAci),
                      expression: "!(jsSendHide && isAci)"
                    }
                  ],
                  attrs: {
                    label: _vm.getItemTitle("Tel"),
                    title: _vm.$t("SeaExport.Phone")
                  }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.readonly
                            ? ""
                            : _vm.$t("SeaExport.Optional"),
                          no: "29"
                        },
                        model: {
                          value: _vm.addressForm.notifyTel,
                          callback: function($$v) {
                            _vm.$set(_vm.addressForm, "notifyTel", $$v)
                          },
                          expression: "addressForm.notifyTel"
                        }
                      }),
                      _c(
                        "span",
                        {
                          staticClass: "center-label",
                          attrs: { title: _vm.$t("SeaExport.Fax") }
                        },
                        [_vm._v(_vm._s(_vm.getItemTitle("Fax")))]
                      ),
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.readonly
                            ? ""
                            : _vm.$t("SeaExport.Optional"),
                          no: "30"
                        },
                        model: {
                          value: _vm.addressForm.notifyFax,
                          callback: function($$v) {
                            _vm.$set(_vm.addressForm, "notifyFax", $$v)
                          },
                          expression: "addressForm.notifyFax"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _vm.showSecondNotifyParty
            ? _c(
                "div",
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.getItemTitle("Second Notify Party"),
                        title: _vm.$t("SeaExport.SecondNotifierName")
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.readonly ? "" : "CODE",
                          no: "31"
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            return _vm.showSenderAndReceiverDialog(
                              "alsonotify",
                              5
                            )
                          }
                        },
                        model: {
                          value: _vm.addressForm.alsonotifyLine1,
                          callback: function($$v) {
                            _vm.$set(_vm.addressForm, "alsonotifyLine1", $$v)
                          },
                          expression: "addressForm.alsonotifyLine1"
                        }
                      }),
                      _c("el-input", {
                        attrs: { no: "32" },
                        nativeOn: {
                          dblclick: function($event) {
                            return _vm.showSenderAndReceiverDialog(
                              "alsonotify",
                              5
                            )
                          }
                        },
                        model: {
                          value: _vm.addressForm.alsonotifyLine2,
                          callback: function($$v) {
                            _vm.$set(_vm.addressForm, "alsonotifyLine2", $$v)
                          },
                          expression: "addressForm.alsonotifyLine2"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.getItemTitle("Address"),
                        title: _vm.$t("SeaExport.Address")
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "33" },
                        nativeOn: {
                          dblclick: function($event) {
                            return _vm.showSenderAndReceiverDialog(
                              "alsonotify",
                              5
                            )
                          }
                        },
                        model: {
                          value: _vm.addressForm.alsonotifyLine3,
                          callback: function($$v) {
                            _vm.$set(_vm.addressForm, "alsonotifyLine3", $$v)
                          },
                          expression: "addressForm.alsonotifyLine3"
                        }
                      }),
                      _c("el-input", {
                        attrs: { no: "34" },
                        nativeOn: {
                          dblclick: function($event) {
                            return _vm.showSenderAndReceiverDialog(
                              "alsonotify",
                              5
                            )
                          }
                        },
                        model: {
                          value: _vm.addressForm.alsonotifyLine4,
                          callback: function($$v) {
                            _vm.$set(_vm.addressForm, "alsonotifyLine4", $$v)
                          },
                          expression: "addressForm.alsonotifyLine4"
                        }
                      }),
                      _c("el-input", {
                        attrs: { no: "35" },
                        nativeOn: {
                          dblclick: function($event) {
                            return _vm.showSenderAndReceiverDialog(
                              "alsonotify",
                              5
                            )
                          }
                        },
                        model: {
                          value: _vm.addressForm.alsonotifyLine5,
                          callback: function($$v) {
                            _vm.$set(_vm.addressForm, "alsonotifyLine5", $$v)
                          },
                          expression: "addressForm.alsonotifyLine5"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.getItemTitle("Country"),
                        title: _vm.$t("SeaExport.Country")
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-input", {
                            attrs: { maxlength: 2, no: "36" },
                            model: {
                              value: _vm.addressForm.alsonotifyCountry,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.addressForm,
                                  "alsonotifyCountry",
                                  $$v
                                )
                              },
                              expression: "addressForm.alsonotifyCountry"
                            }
                          }),
                          _c(
                            "span",
                            {
                              staticClass: "center-label",
                              attrs: { title: _vm.$t("SeaExport.Province") }
                            },
                            [_vm._v(_vm._s(_vm.getItemTitle("State")))]
                          ),
                          _c("el-input", {
                            attrs: { maxlength: _vm.maxInputLength, no: "37" },
                            model: {
                              value: _vm.addressForm.alsonotifyProvince,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.addressForm,
                                  "alsonotifyProvince",
                                  $$v
                                )
                              },
                              expression: "addressForm.alsonotifyProvince"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.getItemTitle("City"),
                        title: _vm.$t("SeaExport.City")
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-input", {
                            attrs: { no: "38" },
                            model: {
                              value: _vm.addressForm.alsonotifyCity,
                              callback: function($$v) {
                                _vm.$set(_vm.addressForm, "alsonotifyCity", $$v)
                              },
                              expression: "addressForm.alsonotifyCity"
                            }
                          }),
                          _c(
                            "span",
                            {
                              staticClass: "center-label",
                              attrs: { title: _vm.$t("SeaExport.ZIP") }
                            },
                            [_vm._v(_vm._s(_vm.getItemTitle("Zip")))]
                          ),
                          _c("el-input", {
                            attrs: { no: "39" },
                            model: {
                              value: _vm.addressForm.alsonotifyPostalcode,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.addressForm,
                                  "alsonotifyPostalcode",
                                  $$v
                                )
                              },
                              expression: "addressForm.alsonotifyPostalcode"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.getItemTitle("Tel"),
                        title: _vm.$t("SeaExport.Phone")
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.readonly
                                ? ""
                                : _vm.$t("SeaExport.Optional"),
                              no: "40"
                            },
                            model: {
                              value: _vm.addressForm.alsonotifyTel,
                              callback: function($$v) {
                                _vm.$set(_vm.addressForm, "alsonotifyTel", $$v)
                              },
                              expression: "addressForm.alsonotifyTel"
                            }
                          }),
                          _c(
                            "span",
                            {
                              staticClass: "center-label",
                              attrs: { title: _vm.$t("SeaExport.Fax") }
                            },
                            [_vm._v(_vm._s(_vm.getItemTitle("Fax")))]
                          ),
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.readonly
                                ? ""
                                : _vm.$t("SeaExport.Optional"),
                              no: "41"
                            },
                            model: {
                              value: _vm.addressForm.alsonotifyFax,
                              callback: function($$v) {
                                _vm.$set(_vm.addressForm, "alsonotifyFax", $$v)
                              },
                              expression: "addressForm.alsonotifyFax"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c("bill-address-dialog", {
        attrs: { visible: _vm.billAddressDialog.visible, job: _vm.job },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.billAddressDialog, "visible", $event)
          },
          callback: _vm.codeSearchCallback
        }
      }),
      _c("search-box-afr-address-dialog", {
        attrs: {
          visible: _vm.searchBoxAfrAddressDialog.visible,
          params: _vm.searchBoxAfrAddressDialog.params,
          "customer-type": _vm.customerType
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.searchBoxAfrAddressDialog, "visible", $event)
          },
          selected: function(p) {
            _vm.selectionItemHandlerByType(p)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }